import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'family.ineliglbeOverlay.member.heading',
		defaultMessage: 'Oh no! This Family plan is full',
		description: "Explanation of why the user can't join the plan",
	},
	copy: {
		id: 'family.ineliglbeOverlay.member.copy',
		defaultMessage: 'Please reach out to the Plan Admin, {name}, to request access.',
		description: 'Telling the user who they should contact',
	},
	createAccountCta: {
		id: 'family.ineliglbeOverlay.member.createAccountCta',
		defaultMessage: 'Create a Free Account',
		description: 'Button copy to send the user to signup',
	},
	backToCalmCta: {
		id: 'family.ineliglbeOverlay.member.backToCalmCta',
		defaultMessage: 'Back to Calm.com',
		description: 'Button copy to send the homepage',
	},
});
